module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/day03_04_stay-c9207a8e11b4db8dfc0dd54895fccb98.jpg";